import type { ArrayType, Is, NonEmptyArray, ReadonlyNonEmptyArray } from '../Types'

type NotEmptyConstraint = readonly unknown[] | unknown[]
type NonEmptyArrayTernary<T extends NotEmptyConstraint> = Is<T, readonly unknown[], ReadonlyNonEmptyArray<ArrayType<T>>, NonEmptyArray<ArrayType<T>>>

export const isNotEmpty = <T extends NotEmptyConstraint>(arr: T): arr is NonEmptyArrayTernary<T> & typeof arr => arr.length > 0

export const getLastElement = <T>(arr: ReadonlyNonEmptyArray<T>): T => arr[arr.length - 1] as T
